import _ from 'lodash'
import BaseStandardReportForm from './base-standard-report-edit-form'
import CurrentFiltersView from 'scoreboard/reports/common/current-filters'
import EditRepeatByPreview from './edit-repeat-by-preview'
import NonDatasetReportFilterWizard from 'scoreboard/reports/wizard/common/non-dataset-report-filter-wizard'
import calendars from 'scoreboard/components/calendars'
import i18n from 'scoreboard/components/i18n'

const BaseNonDatasetReportForm = BaseStandardReportForm.extend({

	filterView: function(el, model) {
		let view = new CurrentFiltersView({
			el,
			model,
			type: this.model.get('subtype')
		})
		view.on('addFilter', this.showAddFilterDialog.bind(this))
		return view
	},

	editRepeatByPreview(headerCell) {
		let { model } = this

		const breakdown = _.get(headerCell, 'options.breakdownReference.breakdown')
		if (breakdown.has('range')) {
			let rangePreviewOpts = _.extend({
				model,
				headerCell,
				breakdown,
				label: this._maybeGenerateTimeBreakdownLabel(breakdown)
			}, this._editPeriodRangeOptions())
			return new EditRepeatByPreview(rangePreviewOpts)
		} else {
			return BaseStandardReportForm.prototype.editRepeatByPreview.apply(this, arguments)
		}
	},

	_maybeGenerateTimeBreakdownLabel: function (breakdown) {
		if (breakdown.isTimeBasedBreakdown(this.model)) {
			// no calendar id on the range means we are using the
			// current/default calendar setting
			const calendarId = breakdown.get('range').calendarId
			return _.isNil(calendarId) ?
				i18n.get('charts.chart.currentCalendar') :
				calendars.calendarsById[calendarId].label

		}
	},

	/**
	 * Options to pass in creating the edit period range view, subclasses override
	 * for domain specific parameters
	 * @private
	 */
	_editPeriodRangeOptions: function () {
	},

	showAddFilterDialog() {
		this.wizard && this.wizard.remove()
		this.wizard = new NonDatasetReportFilterWizard(_.defaults(
			{meta: this._filterMeta}, this._filterOptions()))
		this.listenTo(this.wizard, 'done', (value, filterKey) => {
			this.model.setFilter(value, filterKey)
			this.render()
		})

		//clone the existing filters to prevent accidental modifications
		this.wizard.start({
			titlePrefixCode: this._filterTitle,
			filterExplanationTemplate: this._filterBanner(),
			organizationId: this.model.get('organizationId'),
			filters: _.cloneDeep(this.model.get('filters'))
		})
	},

	_filterOptions: function() {
		return {}
	}

})

export default BaseNonDatasetReportForm

BaseNonDatasetReportForm.__filename__ = 'reports/common/base-non-dataset-report-form.js'
